import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

// Modules
import company from './modules/company'
import complex from './modules/complex'
import favorites from './modules/favorites'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    company,
    complex,
    favorites
  }
})
